import { render, staticRenderFns } from "./d_materiality-matrix.vue?vue&type=template&id=53c5b276&scoped=true"
import script from "./d_materiality-matrix.vue?vue&type=script&lang=js"
export * from "./d_materiality-matrix.vue?vue&type=script&lang=js"
import style0 from "./d_materiality-matrix.vue?vue&type=style&index=0&id=53c5b276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5b276",
  null
  
)

export default component.exports